import React from 'react'

function Card({ children, className, ...props }) {
    return (
      <div className={`bg-white rounded-md shadow-lg ${className}`} {...props}>
        {children}
      </div>
    );
  }
export default Card